"use strict";
/**
 * @tama/api-contract — the wire format, defined once.
 *
 * The API validates inbound requests with these schemas and the client parses
 * responses with them, so a mismatch between the two fails loudly at the
 * boundary instead of surfacing as a confusing `undefined` three layers in.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./schemas"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./routes"), exports);
//# sourceMappingURL=index.js.map